import React from "react";

const isDev = process.env.REACT_APP_DEVELOPMENT_MODE === "development";
const logoSrc = isDev ? "./dashboard/images/meetuslogosvg-dark.svg" : "./images/meetuslogosvg-dark.svg";

const MeetusVrVerticalIcon = ({ className }) => (
  <div
    className={className}
    style={{
      width: 50,
      height: 200,
      position: "relative",
    }}
  >
    <img
      src={logoSrc}
      alt="MeetusVR"
      style={{
        width: 170,
        maxWidth: "none",
        height: "auto",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%) rotate(-90deg)",
      }}
    />
  </div>
);

export default MeetusVrVerticalIcon;
